import { render, staticRenderFns } from "./IndividualSubscriptionRedirectModal.vue?vue&type=template&id=a23242ae&"
import script from "./IndividualSubscriptionRedirectModal.vue?vue&type=script&lang=ts&"
export * from "./IndividualSubscriptionRedirectModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a23242ae')) {
      api.createRecord('a23242ae', component.options)
    } else {
      api.reload('a23242ae', component.options)
    }
    module.hot.accept("./IndividualSubscriptionRedirectModal.vue?vue&type=template&id=a23242ae&", function () {
      api.rerender('a23242ae', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "common/src/subscription-quote/IndividualSubscriptionRedirectModal.vue"
export default component.exports